
import { Component, Vue, Prop } from 'vue-property-decorator';
import { iTextList } from '@/interface/exchange-code';
// import { login } from '@/api/users';

@Component({})
export default class extends Vue {
  @Prop({ default: '1' }) size!: string;
  @Prop() keyIndex!: number;
  @Prop() text!: any;
  @Prop() openTypeList!: any;

  deleteText(keyIndex: number) {
    this.$emit('deleteText', keyIndex);
  }
  mounted() {}
}
